// extracted by mini-css-extract-plugin
export var emailBlockLink = "_jf-0";